<template>
  <footer class="footer px-4 mx-2">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} ChinesePod LLC
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <li class="nav-item">
            <a href="/pricing" class="nav-link">Pricing</a>
          </li>
          <li class="nav-item">
            <a href="/corporate" class="nav-link">For Companies</a>
          </li>
          <li class="nav-item">
            <a href="/academic-offers" class="nav-link">For Schools</a>
          </li>
          <li class="nav-item">
            <a href="/start-learning-mandarin" class="nav-link">About Us</a>
          </li>
          <li class="nav-item">
            <a href="/contact" class="nav-link">Contact Us</a>
          </li>
          <li class="nav-item">
            <a href="/blog" class="nav-link">Blog</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
